<template>
  <a-drawer
    :maskClosable="false"
    width="80%"
    title="详情"
    placement="right"
    :closable="true"
    :visible="visible"
    @close="onClose"
  >
    <a-tabs @change="callback" :activeKey="active" type="card">
      <a-tab-pane :key="1" tab="基本信息">
        <div v-if="form && form.id">
          <a-descriptions :column="4" title="" class="full-width-descriptions">
            <!-- <a-descriptions-item label="联系电话"> {{ form.mobile }}</a-descriptions-item> -->
            <a-descriptions-item label="订单号"> {{ form.orderNo }} </a-descriptions-item>
            <a-descriptions-item label="支付"> {{ form.payType == 1 ? '积分' : '金豆' }}</a-descriptions-item>
            <a-descriptions-item label="收件人姓名"> {{ form.receiverName }} </a-descriptions-item>
            <a-descriptions-item label="收件人电话"> {{ form.receiverMobile }} </a-descriptions-item>
            <a-descriptions-item label="收件人地址"> {{ form.receiverAddress }} </a-descriptions-item>
            <a-descriptions-item label="订购用户名称"> {{ form.userName }} </a-descriptions-item>
            <a-descriptions-item label="订购用户手机号"> {{ form.receiverMobile }} </a-descriptions-item>
            <a-descriptions-item label="商品总数"> {{ form.productNums }} </a-descriptions-item>
            <a-descriptions-item label="订单运费"> {{ form.freightAmount }} </a-descriptions-item>
            <a-descriptions-item label="配送类型">
              {{
                form.dvyType == 1 ? '快递' : form.dvyType == 2 ? '自提' : form.dvyType == 3 ? '无需快递' : '同城配送'
              }}
            </a-descriptions-item>
            <a-descriptions-item label="状态">
              {{ form.status == 1 ? '待付款' : form.status == 2 ? '待发货' : form.status == 3 ? '待收货' : '已完成' }}
            </a-descriptions-item>
            <a-descriptions-item label="备注"> {{ form.remark }} </a-descriptions-item>
          </a-descriptions>
          <a-table :columns="columns" :data-source="form.children">
            <div slot="pic" slot-scope="text, record">
              <div v-viewer>
                <img
                  @error="
                    (e) => {
                      e.target.src = errorImage
                    }
                  "
                  :src="$url + record.pic"
                  alt=""
                />
              </div>
            </div>
          </a-table>
        </div>
      </a-tab-pane>
    </a-tabs>
  </a-drawer>
</template>
  <script>
import { tableMixin } from '@/store/table-mixin'
import { getObj } from '@/api/pressure/integralOrder'
export default {
  mixins: [tableMixin],
  name: 'Post',
  data() {
    return {
      visible: false,
      form: {},
      dataForm: {},
      columns: [
        {
          title: '商品名称',
          dataIndex: 'prodName',
          key: 'prodName',
          width: 200,
          align: 'center',
        },
        {
          title: '商品图片',
          dataIndex: 'pic',
          scopedSlots: { customRender: 'pic' },
          key: 'pic',
          align: 'center',
        },
        {
          title: '商品个数',
          dataIndex: 'prodCount',
          key: 'prodCount',
          align: 'center',
        },
        {
          title: '商品积分',
          dataIndex: 'productIntegral',
          key: 'prodName',
          align: 'center',
        },
        {
          title: '商品总积分',
          dataIndex: 'productTotalIntegral',
          key: 'prodName',
          align: 'center',
        },
      ],
      errorImage: require('/src/assets/images/defaultImg.png'),
      active: 1,
      placeholderImage: '~@/assets/images/defaultImg.png',
      default: 'this.src="' + require('@/assets/images/defaultImg.png') + '"',
    }
  },
  filters: {},
  created() {
    console.log(this.router, '111111222')

    this.type = 1
  },
  computed: {
    hasPermission() {
      return (permission) => {
        if (this.$store.state.user.userTentant.type === 0) {
          return true
        } else {
          return this.$store.state.user.permissions.includes(permission)
        }
        // return true
      }
    },
  },
  watch: {},
  methods: {
    init(e, index) {
      console.log(e, index, 'sdd的点点滴滴')
      this.visible = true
      getObj(e.id).then((res) => {
        console.log(res, '对对对买买买')
        if (res.data.payType == 1) {
          this.columns[3].title = '商品积分'
          this.columns[4].title = '商品总积分'
        } else {
          this.columns[3].title = '商品金豆'
          this.columns[4].title = '商品总金豆'
        }
        this.form = res.data
      })
      // this.
      // getTenant(e.id).then((res) => {
      //   const startTime = this.convertMinutes(res.data.startTime)
      //   const endTime = this.convertMinutes(res.data.endTime)
      //   let arr = []
      //   let array = []
      //   if (res.data.businessDays && res.data.businessDays.length) {
      //     res.data.businessDays.forEach((v) => {
      //       this.options.forEach((item) => {
      //         if (v == item.id) {
      //           arr.push(item.name)
      //         }
      //       })
      //     })
      //     res.data.businessDay = arr.join(',')
      //   }
      //   if (res.data.evaluateOptions && res.data.evaluateOptions.length) {
      //     res.data.evaluateOptions.forEach((v) => {
      //       this.evaluationOptions.forEach((item) => {
      //         if (v == item.value) {
      //           array.push(item.label)
      //         }
      //       })
      //     })
      //     res.data.evaluateOption = array.join(',')
      //   }
      //   res.data.startTimes = startTime + '-' + endTime
      //   this.form = res.data
      //   this.dataForm = e
      //   this.form.panoramaImg = null
      //   this.active = index
      //   this.visible = true
      // })
    },
    convertMinutes(minutes) {
      const hours = Math.floor(minutes / 60) // 计算小时
      const remainingMinutes = minutes % 60 // 计算剩余的分钟
      return `${hours > 10 ? hours : '0' + hours}:${remainingMinutes > 10 ? remainingMinutes : '0' + remainingMinutes}`
    },
    onImageError(event) {
      // 将事件的目标（即<img>元素）的src设置为本地占位图
      event.target.src = this.placeholderImage

      // 如果你想进一步处理错误，比如发送错误报告，可以在这里添加代码
      // ...
    },
    onClose() {
      const that = this
      this.$confirm({
        title: '是否确认关闭清空数据',
        onOk() {
          that.visible = false
          that.form.id = ''
        },
        onCancel() {},
      })
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    // 切换tabs
    callback(e) {
      console.log(e, '顶顶顶顶')
      this.active = e
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      let ids = []
      const postIds = row.id || this.ids
      console.log(postIds, 'postIdspostIds')
      if (row.id) {
        ids = [{ id: postIds }]
      } else {
        postIds.forEach((v) => {
          ids.push({ id: v })
        })
      }
      this.$confirm({
        title: '是否确认冻结此用户?',
        onOk() {
          return frozenTenant(ids).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('冻结成功', 3)
          })
        },
        onCancel() {},
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'system/post/export',
            {
              ...that.queryParam,
            },
            `post_${new Date().getTime()}.xlsx`
          )
        },
        onCancel() {},
      })
    },
  },
}
</script>
<style lang="less"  scoped>
img {
  width: 80px;
  height: 80px;
}
.full-width-descriptions {
  width: 100% !important;
  // background: red;
  box-sizing: border-box; /* 确保包含内边距和边框 */
}
.ant-descriptions-item {
  width: 25%;
  // background: red;
}
.ant-descriptions-item-label {
  width: 100px;
  // background: red;
  text-align: left;
}
// /deep/.ant-tabs-tab {
//   border: none !important;
//   padding-top: 0 !important;
// }
</style>
  